/**
 * main.js
 * Application entry point for ReArch Executive Reporting.
 * Creates the Vue app, registers the router, and mounts to #app.
 */

import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index.js'
import './assets/main.css'

const app = createApp(App)

app.use(router)

app.mount('#app')
